import { ListType } from 'modules/domains/list';
import { FETCH_LISTS_URL } from 'api/ManageListsAPI';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { useEffect } from 'react';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';
import { List } from '../types';

const SORT_DIRECTIONS_TO_LIST_SORTING = {
  [SORT_DIRECTIONS.ASCENDING]: 'asc',
  [SORT_DIRECTIONS.DESCENDING]: 'desc',
} as const;

type ListsQueryHookOptions = {
  sortBy: string;
  sortDirection: SORT_DIRECTIONS;
  currentPage: number;
  pageSize: number;
  search: string | null;
  type: ListType | null;
};

type ListsRequest = {
  page: number;
  pageSize: number;
  searchText?: string;
  emailListType?: ListType;
  orderBy: string;
  sorting: (typeof SORT_DIRECTIONS_TO_LIST_SORTING)[SORT_DIRECTIONS];
};

type ListsResponse = {
  results: List[];
  total: number;
};

export const useListsQuery = ({
  sortBy,
  sortDirection,
  currentPage,
  pageSize,
  search,
  type,
}: ListsQueryHookOptions) => {
  const { mutate, isLoading, isError, data, error } = useRestMutation<ListsResponse, ListsRequest>(
    FETCH_LISTS_URL,
    ApiMethod.post,
  );

  const refetch = () =>
    mutate({
      orderBy: sortBy,
      sorting: SORT_DIRECTIONS_TO_LIST_SORTING[sortDirection],
      page: currentPage,
      pageSize,
      emailListType: type ?? undefined,
      searchText: search ?? undefined,
    });

  useEffect(() => {
    refetch();
  }, [sortBy, sortDirection, currentPage, pageSize, type, search]);

  return { isLoading, isError, data, refetch, error };
};
